import React from "react";
import { Box, ButtonBase } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import WITHDRAWN_IMAGE from "../../../images/Banner/withdrawn.jpg";

const BELL_MT = '"Bell MT", Georgia, "Times New Roman", serif';


/**
 * Left column: thumbnails and the main image (click opens the zoom dialog).
 * Lot details are in LotSummary (right column) and LotCatalogueFields (under this).
 */
export default function LotDetails({
  isWidraw,
  imageData = [],
  selectedImage,
  selectedImage1,
  setSelectedImage1,
  setZoom,
  title,
}) {
  return (
    <section className="lot-details-bell-mt" style={{ fontFamily: BELL_MT }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "85px minmax(0, 1fr)" },
          gap: { xs: 1.5, lg: 2 },
          width: "100%",
        }}
      >
        <Box sx={{ order: { xs: 2, lg: 1 }, minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "row", lg: "column" },
              gap: 1,
              width: "100%",
              maxHeight: { lg: 600 },
              overflowX: { xs: "auto", lg: "hidden" },
              overflowY: { xs: "hidden", lg: "auto" },
              scrollbarWidth: "thin",
            }}
          >
            {isWidraw !== 1 && (imageData.length ? imageData.map((image) => image.img_url) : [selectedImage]).filter(Boolean).map(
              (imgUrl, index) => (
                <ButtonBase
                  key={`${imgUrl}-${index}`}
                  onClick={() => setSelectedImage1(imgUrl)}
                  sx={{
                    width: { xs: 65, lg: 85 },
                    height: { xs: 75, lg: 100 },
                    minWidth: { xs: 65, lg: 85 },
                    minHeight: { xs: 75, lg: 100 },
                    flexShrink: 0,
                    border: selectedImage1 === imgUrl ? "2px solid #000" : "1px solid #eee",
                    backgroundColor: "#fff",
                    opacity: selectedImage1 === imgUrl ? 1 : 0.6,
                    "&:hover": { opacity: 1, borderColor: "#999" },
                  }}
                >
                  <Box component="img" src={imgUrl} alt={`Lot image ${index + 1}`} sx={{ width: "100%", height: "100%", objectFit: "contain", p: 0.5 }} />
                </ButtonBase>
              )
            )}
          </Box>
        </Box>

        <Box sx={{ order: { xs: 1, lg: 2 }, minWidth: 0 }}>
          <Box
            onClick={() => setZoom(true)}
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: 350, sm: 450, lg: 600 },
              backgroundColor: "#fff",
              cursor: "zoom-in",
              border: "1px solid #f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={isWidraw === 1 ? WITHDRAWN_IMAGE : selectedImage1}
              alt={title || "Lot artwork"}
              sx={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
            />
            {isWidraw !== 1 && (
              <Box sx={{ position: "absolute", right: 12, bottom: 12, width: 34, height: 34, borderRadius: "50%", bgcolor: "rgba(255,255,255,.9)", display: "grid", placeItems: "center" }}>
                <ZoomInIcon sx={{ fontSize: 18 }} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>

    </section>
  );
}
